<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'COMMON.SETTINGS' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'LEAD_INTEGRATIONS.FACEBOOK.TITLE' | translate"
        [previousPageUrl]="'/facebook-ad-leads'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-raised-button (click)="revertSettings()">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="saveSettings()">
        {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <app-vbox titleText="{{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.HEADING' | translate }}">
      <ng-container content>
        <app-facebook-settings (selectedSettings)="updateDupeCriteria($event)"></app-facebook-settings>
      </ng-container>
    </app-vbox>

    <div>&nbsp;</div>

    <app-vbox titleText="{{ 'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.HEADING' | translate }}">
      <ng-container content>
        <app-lead-qualification-settings></app-lead-qualification-settings>
      </ng-container>
    </app-vbox>
  </glxy-page-wrapper>
</glxy-page>
